import React, { FC, useState } from 'react'
import { Button } from '@roo/roo'
import PopConfirm from '@roo/roo/PopConfirm'
import { useTranslation } from '@sailor/i18n-web'
import { successToast } from '@/common/utils/toast'
import { deleteRulePackage } from '../utils/api'
import { useRequest } from 'ahooks'

interface DeleteRuleProps {
  rulePackageId: number
  onSuccess?: () => void
  disabled?: boolean
}

const DeleteRule: FC<DeleteRuleProps> = ({ rulePackageId, onSuccess, disabled }) => {
  const { t } = useTranslation()

  const { loading, run: handleConfirm } = useRequest(async () => {
    await deleteRulePackage(rulePackageId)
    successToast(t('e_pc_del_success', '删除成功'))
    onSuccess?.()
  }, {
    manual: true,
  })

  return (
    <PopConfirm
      content={t('e_pc_delete_no_recover', '删除后将无法恢复')}
      placement="left"
      onConfirm={handleConfirm}
      cancelText={t('e_pc_cancel_button', 'Cancel')}
      confirmText={t('e_pc_confirm_button', 'Confirm')}
      disabled={disabled || loading}
    >
      <Button
        type="brand-text"
        loading={loading}
        disabled={disabled}
      >
        {t('e_pc_del', '删除')}
      </Button>
    </PopConfirm>
  )
}

export default DeleteRule